export default __webpack_public_path__ + "static/media/press_0.eccc45d7.jpg";